(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ani-audit-hero"] && !Shopify.designMode) return;
  try {
    
let aniChatAttempts=0;
function positionAniHomeChat(){
  if(!document.querySelector('.ani-mobile-cta'))return;
  const root=document.querySelector('body > .skip-launcher-animation')?.shadowRoot;
  if(root){
    if(!root.getElementById('ani-home-chat-position')){
      const style=document.createElement('style');
      style.id='ani-home-chat-position';
      style.textContent='@media(max-width:767px){.main-element.left{left:auto!important;right:14px!important;bottom:calc(80px + env(safe-area-inset-bottom))!important}}';
      root.appendChild(style);
    }
    return;
  }
  if(++aniChatAttempts<20)setTimeout(positionAniHomeChat,500);
}
positionAniHomeChat();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ani-pack-content"] && !Shopify.designMode) return;
  try {
    
/* Anchor navigation for the pack configurator and its lower-page guides. */
document.addEventListener('click', function (event) {
  if (!document.querySelector('[data-pack-lab]')) return;
  const link = event.target.closest('a[href="#anitials-pack-configurator"], a[href="#ani-initial-letters"], a[href="#ani-initial-details"]');
  if (!link) return;
  const target = document.querySelector(link.getAttribute('href'));
  if (!target) return;
  event.preventDefault();
  event.stopPropagation();
  target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
}, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ani-pack-unified-content"] && !Shopify.designMode) return;
  try {
    
/* Anchor navigation for the pack configurator and its lower-page guides. */
document.addEventListener('click', function (event) {
  if (!document.querySelector('[data-pack-lab]')) return;
  const link = event.target.closest('a[href="#anitials-pack-configurator"], a[href="#ani-initial-letters"], a[href="#ani-initial-details"]');
  if (!link) return;
  const target = document.querySelector(link.getAttribute('href'));
  if (!target) return;
  event.preventDefault();
  event.stopPropagation();
  target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
}, true);

  } catch(e) { console.error(e); }
})();
})();
